/** @format */

import {IfElse, If} from 'frontier-utilities';
import React, {useCallback} from 'react';
import SuperAgent from 'superagent';

export const NameColumn = props => {
    const [isLoading, setIsLoading] = React.useState(false);
    const {address, onSetDefaultComplete} = props;

    const handleSetDefault = useCallback(() => {
        setIsLoading(true);
        SuperAgent.post('/account/addresses/set-address-default/' + address.id)
            .set('Accept', 'application/json')
            .send({is_default: !address.is_default_address})
            .end((err, response) => {
                onSetDefaultComplete(
                    address.is_default_address
                        ? 'Address removed as default'
                        : 'Address set as default'
                );
                setIsLoading(false);
            });
    });

    return (
        <div className="addresses-list-05vn__default d-flex align-items-center justify-content-start gap-4">
            <button className="m-0 p-0" onClick={handleSetDefault}>
                <IfElse condition={isLoading}>
                    <i
                        className="fa fa-spinner fa-spin color-structure-darker"
                        style={{fontSize: 24}}
                    />
                    <IfElse condition={address.is_default_address}>
                        <i
                            className="color-accent-primary fa-solid fa-star"
                            style={{fontSize: 24}}
                        />
                        <i
                            className="color-structure-darker fa-regular fa-star"
                            style={{fontSize: 24}}
                        />
                    </IfElse>
                </IfElse>
            </button>
            <div>
                <If condition={address.is_default_address}>
                    <p className="m-0 color-structure-darker">Default</p>
                </If>
                <h4 className="m-0">{address.company?.replaceAll('(', '')?.replaceAll(')', '')}</h4>
                <p className="m-0">{address.name}</p>
            </div>
        </div>
    );
};
